import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { SBACurrencyInput } from "../../UiComponents/SBACurrencyInput";
export const ExchangeRateModal = ({ showModal, value, onBlur ,closeModal }) => {
    debugger;
    const [exchangeRate, setExchangeRate] = useState(value);
   
    useEffect(() => {
        setExchangeRate(value);
    }, [value]);
    const handleonBlur = (e) => {
        if (onBlur) {
            onBlur(e);
        }
    };
    const handleCloseModal=()=>{
        if(closeModal)
        {
            closeModal();
        }
    }
    return <>
        {<Modal show={showModal}>
            <Modal.Header closeButton onClick={()=>{handleCloseModal()}}>
                <Modal.Title>Exchange Rate</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4">
                    <label className="mb-1 label"> Exchange Rate</label>
                    <div className="d-flex gap-2">
                        <SBACurrencyInput
                            className={"form-control w-75"}

                            decimalsLimit={2}
                            value={exchangeRate}
                            onBlur={(e) => {
                                handleonBlur(e)
                            }}
                            disableGroupSeparators={true}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                <button className='p-sm-btn mx-1' onClick={closeModal} >
                    Ok
                </button>
            </Modal.Footer>
        </Modal>}
    </>
}